import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

const OtpRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const values = queryString.parse(location.search);

  // console.log('values', values);

  const responseDecoded = window.atob(values.r);

  sessionStorage.setItem('otpData', responseDecoded);

  navigate('/');

  return <div />;
};

export default OtpRedirect;
